import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'

import theme from '../../../styles/theme'

const HeaderBar = styled(View)`
  flex-direction: row;
  width: 100%;
  padding: ${theme.gutterUnit}px;
  height: ${theme.teamBarHeight}px;
  background-color: ${theme.colours.darkBlue};
  align-items: center;
  justify-content: space-between;
`

class PageHeader extends PureComponent {
  render () {
    const { hideTeam } = this.props
    let teamName = ''
    if (!hideTeam && this.props.name) {
      teamName = `Team ${this.props.teamNumber}: ${String(this.props.name).toUpperCase()} BANK`
    }
    return (
      <HeaderBar>
        <Text white bold overrides={{ flex: 1 }}>{teamName}</Text>
        <Text white bold>{this.props.text || ''}</Text>
        <Text white bold overrides={{ flex: 1 }} />
      </HeaderBar>
    )
  }
}

const mapStateToProps = (state) => ({
  name: state.team.name,
  teamNumber: state.team.id
})

export default connect(mapStateToProps, {})(PageHeader)
